import { render, staticRenderFns } from "./Sucursalesdel.vue?vue&type=template&id=5a59228d"
import script from "./Sucursalesdel.vue?vue&type=script&lang=js"
export * from "./Sucursalesdel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports